import React from "react";
import { Link } from "react-router-dom";
import "./styles/navBar.css";
import INFO from "../../data/user";
const NavBar = (props) => {
	const { active } = props;

	return (
		<React.Fragment>
			<div className="nav">
				<div className="nav-container">
					<div className="nav-logo-container">
						<a href={INFO.socials.linkedin} target="_blank" rel="noreferrer">
						<img src={INFO.main.logo} alt="logo" className="nav-logo" />
						</a>
					</div>
					<nav className="navbar">
						<div className="nav-background">
							<ul className="nav-list">
								<li
									className={
										active === "home"
											? "nav-item active"
											: "nav-item"
									}
								>
									<Link className="nav-item-link" to="/">Home</Link>
								</li>
								<li
									className={
										active === "about"
											? "nav-item active"
											: "nav-item"
									}
								>
									<Link className="nav-item-link" to="/about">About</Link>
								</li>
								<li
									className={
										active === "projects"
											? "nav-item active"
											: "nav-item"
									}
								>
									<Link className="nav-item-link" to="/projects">Projects</Link>
								</li>
								<li
									className={
										active === "resume"
											? "nav-item active"
											: "nav-item"
									}
								>
									<Link className="nav-item-link" to="/resume">Resume</Link>
								</li>
								<li
									className={
										active === "contact"
											? "nav-item active"
											: "nav-item"
									}
								>
									<Link className="nav-item-link" to="/contact">Contact</Link>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</div>
		</React.Fragment>
	);
};

export default NavBar;
